import { emojiOf } from "@lagerlog/core";

/**
 * The picture of a pantry article in a column of its own, as in the shopping list: the base
 * product's emoji, with a green „bio“ on its corner for organic food.
 */
export function Emoji({ fields }: { fields: Record<string, unknown> }) {
  return (
    <span className="emoji" aria-hidden="true">
      {emojiOf(fields)}
      {fields.organic === true && (
        <svg className="bio-badge" viewBox="0 0 26 23" focusable="false">
          <polygon points="7,1 19,1 25,11.5 19,22 7,22 1,11.5" />
          <text x="13" y="15.4" textAnchor="middle">
            bio
          </text>
        </svg>
      )}
    </span>
  );
}
